module.exports = __webpack_public_path__ + "static/media/bk.95bba380.JPG";